import { WithAuthenticatorOptions, withAuthenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { Auth as AmplifyAuth } from "aws-amplify";

import React from "react";
import { ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// import AuthenticatedStatus from "../../views/login/CheckAuth";
// import { useUser } from '/@/context/user-context'
// import { useAuth } from "/@/context/auth-context";

function Auth(item: any) {
  const [authenticatedUserData, setAuthenticatedUserData] = useState<any>(null);
  // navigate(-1);
  // const { getUrlQueryOfUnloginUser, clearUrlQueryOfUnloginUser } = useUser() as any;

  // const { signIn } = useAuth() as any

  // const authenticatedUserDataTmp = AuthenticatedStatus();
  // if (authenticatedUserDataTmp !== authenticatedUserData) {
  //   setAuthenticatedUserData(authenticatedUserDataTmp);
  // }
  // const navigate = useNavigate();

  // useEffect(() => {
  //   if (authenticatedUserData) {
  //     signIn(authenticatedUserData)
  //     let urlQueryOfUnloginUser = getUrlQueryOfUnloginUser();
  //     clearUrlQueryOfUnloginUser();
  //     if(urlQueryOfUnloginUser) {
  //       navigate(`/search?${urlQueryOfUnloginUser}`);
  //     }else {
  //       navigate(-1);
  //     }
  //   }
  // }, [authenticatedUserData]);

  return null;
}

const federated = {
  google_client_id: "598739707650-40qm33fnu77g3kroujju0uq54l30a4p8.apps.googleusercontent.com",
};

export default withAuthenticator(Auth);
